'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.WaveCharacter = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

require('./index.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var WaveCharacter = exports.WaveCharacter = function WaveCharacter(_ref) {
    var className = _ref.className,
        children = _ref.children;
    return _react2.default.createElement(
        'svg',
        { className: (0, _classnames2.default)('part', className),
            x: '0px',
            y: '0px',
            viewBox: '0 25 80 30' },
        children
    );
};
WaveCharacter.propTypes = {
    className: _propTypes2.default.string.isRequired,
    children: _propTypes2.default.node.isRequired
};

var ScoirWave = function ScoirWave(_ref2) {
    var className = _ref2.className;
    return _react2.default.createElement(
        'div',
        { className: (0, _classnames2.default)('scoir-wave-comp', className) },
        _react2.default.createElement(
            WaveCharacter,
            { className: 's' },
            _react2.default.createElement('path', {
                fillRule: 'evenodd',
                clipRule: 'evenodd',
                d: 'M8.522,47.949c3.329,0,7.113-2.398,7.113-5.762 c0-6.167-9.692-4.626-9.692-6.665c0-0.718,0.579-1.143,1.893-1.143c1.729,0,3.637,0.571,5.042,1.741l2.355-3.24 c-1.78-1.544-4.02-2.456-6.831-2.456c-4.395,0-6.85,2.633-6.85,5.444c0,6.391,9.692,4.576,9.692,6.765 c0,0.819-0.942,1.317-2.467,1.317c-2.414,0-4.29-0.992-5.495-2.186L1,45.118C2.68,46.717,7.174,47.949,8.522,47.949z'
            })
        ),
        _react2.default.createElement(
            WaveCharacter,
            { className: 'co' },
            _react2.default.createElement('path', {
                fillRule: 'evenodd',
                clipRule: 'evenodd',
                d: 'M33.243,33.708c-0.514-1.738-3.784-3.278-6.263-3.278 c-5.074,0-8.796,3.622-8.893,8.738c-0.085,4.606,3.966,9.31,9.04,9.31c8.032,0,10.453-8.159,13.113-11.472l-0.039-0.015 c0.846-1.333,2.254-2.61,4.61-2.61c2.819,0,4.742,2.467,4.742,5.17c0,2.68-2.127,4.799-4.942,4.799 c-1.649,0-4.135-1.266-4.942-2.401c0,0-2.212,3.104-2.131,3.197c0.772,0.872,3.178,3.429,6.977,3.429 c5.209,0,9.268-3.792,9.268-8.831c0-5.043-3.564-9.313-9.268-9.313c-9.708,0-9.217,13.522-17.438,13.522 c-2.695,0-4.703-1.618-4.703-5.17c0-3.456,2.672-5.815,5.336-6.232c1.174-0.185,3.603-0.065,5.507,1.22L33.243,33.708z'
            })
        ),
        _react2.default.createElement(
            WaveCharacter,
            { className: 'i' },
            _react2.default.createElement('rect', {
                x: '56.287',
                y: '30.561',
                fillRule: 'evenodd',
                clipRule: 'evenodd',
                width: '4.391',
                height: '17.21'
            })
        ),
        _react2.default.createElement(
            WaveCharacter,
            { className: 'r' },
            _react2.default.createElement('path', {
                fillRule: 'evenodd',
                clipRule: 'evenodd',
                d: 'M72.309,38.102h-3.646v-3.75h3.646 c1.231,0,2.224,0.657,2.224,1.861C74.532,37.45,73.54,38.102,72.309,38.102z M79,47.771l-3.414-6.356 c1.584-0.563,3.341-2.154,3.341-5.174c0-3.225-2.186-5.619-5.997-5.619h-8.738l0.078,17.149h4.394v-5.816h2.359l3,5.816H79z'
            })
        )
    );
};
ScoirWave.propTypes = {
    className: _propTypes2.default.string
};
exports.default = ScoirWave;
//# sourceMappingURL=index.js.map